<template>
  <div
    class="border my-1 p-1 rounded-md"
  >
    <div class=" mb-2 font-medium leading-none tracking-normal">
      {{ bankName? 'Edit' : 'Tambah' }} Rekening
    </div>
    <b-form @submit.prevent="onSubmit">
      <b-form-group
        id="input-group-1"
        label="Nama Bank"
        label-for="input-2"
        label-cols="4"
        label-cols-lg="4"
      >
        <v-select
          id="input-2"
          v-model="selectedBank"
          placeholder="Ketik untuk mencari.."
          required
          :options="bankList"
          label="name"
        >
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              :required="!selectedBank"
              v-bind="attributes"
              v-on="events"
            >
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        id="input-sm"
        label="Nomor Rekening"
        label-for="input-2"
        label-cols="4"
        label-cols-lg="4"
      >
        <b-form-input
          id="input-sm"
          v-model="accountNumber"
          required
          type="number"
          placeholder="Masukkan nomor rekening"
          @keydown.native="preventEInput"
        />
      </b-form-group>
      <div class="mt-1 text-end">
        <b-button
          class="mr-2"
          variant="outline-secondary"
          size="sm"
          @click="addBank"
        >
          Back
        </b-button>
        <b-button
          size="sm"
          class="rounded-md"
          variant="primary"
          type="submit"
          :disabled="isLoading"
        >Simpan
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { apiGetListBank, apiCreateBankAccount } from './service/api.bankAccount.service'

export default {
  components: {
    VSelect,
  },
  props: {
    accountNumber: {
      type: String,
      default: null,
    },
    bankName: {
      type: String,
      default: '',
    },
    idBank: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bankList: [],
      isLoading: false,
      selectedBank: null,
      localAccountNumber: this.accountNumber || '',
    }
  },
  watch: {
    accountNumber(newValue) {
      this.localAccountNumber = newValue || ''
    },
    bankName: {
      immediate: true,
      handler(newValue) {
        if (this.bankList.length > 0) {
          this.definedBank()
        }
      },
    },
    bankList: {
      immediate: true,
      handler(newValue) {
        if (this.bankName) {
          this.definedBank()
        }
      },
    },
  },
  async mounted() {
    await this.getListBank()
  },

  methods: {
    addBank() {
      this.localAccountNumber = ''
      this.selectedBank = null
      this.$emit('addBank')
    },
    async getListBank() {
      try {
        const { data } = await apiGetListBank()
        this.bankList = data.data
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data bank' })
      }
    },
    preventEInput(event) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault()
      }
    },
    definedBank() {
      // Pastikan bankName ada dan bankList sudah terisi
      if (this.bankName && this.bankList && this.bankList.length > 0) {
        const bankToFind = this.bankList.find(
          // Gunakan 'name' sesuai dengan properti di v-select dan onSubmit
          bank => bank.name === this.bankName,
        )
        if (bankToFind) {
          this.selectedBank = bankToFind
        }
      }
    },
    async onSubmit() {
      this.isLoading = true
      try {
        if (!this.selectedBank) {
          this.$toast_error({ message: 'Silakan pilih bank terlebih dahulu' })
          this.isLoading = false
          return
        }
        if (!this.localAccountNumber || this.localAccountNumber.trim() === '') {
          this.$toast_error({ message: 'Nomor rekening tidak boleh kosong' })
          this.isLoading = false
          return
        }
        await apiCreateBankAccount({
          mode: this.bankName ? 'edit' : 'add',
          bank_code: this.selectedBank.code,
          bank_no: this.localAccountNumber,
          bank_name: this.selectedBank.name,
          id: this.idBank,
        })
        this.$toast_success({ message: `Rekening berhasil ${this.idBank ? 'diupdate' : 'ditambahkan'}` }) // Tambahkan notifikasi sukses
        this.addBank()
        this.$emit('refresh')
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Gagal menambahkan rekening'
        this.$toast_error({ message: errorMessage })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
